import { injectable } from "inversify";
import UserRepository from "../../repositories/UserRepository";
import UserEntity, { UserType } from "../../entities/UserEntity";
import { Either, isLeft } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import SearchResultEntity from "../../entities/SearchResultEntity";

interface _Props {
    userRepository: UserRepository;
}
@injectable()
export default class SearchUsersUseCase {
    private userRepository: UserRepository;
    constructor(props: _Props) {
        this.userRepository = props.userRepository;
    }
    public call = async (_: {
        query?: string, page: number, itemsPerPage: number,
        role?: UserType
    }): Promise<Either<ErrorEntity, SearchResultEntity<UserEntity>>> => {
        return this.userRepository.searchUsers(_);
    }
}

export const SearchUsersUseCaseName = "SearchUsersUseCase";